<template>
  <LoginModule>
    <div class="topBox flex" @click="changeLogWay">
      <span :class="['tips', isScanLog ? 'tips1' : '']"></span>
      <span :class="['icon', isScanLog ? 'icon1' : '']"></span>
    </div>
    <h2 class="title">教师登录</h2>
    <div class="codeBox" v-if="isScanLog">
      <div class="wrap">
        <img class="codeImg" :src="codeDataObj?.qrCodeUrl" alt="" />
        <div class="maskBox" v-show="isExpireTime" @click="getCodeImg">
          <p class="iconfont recite_icon_again"></p>
          <p>二维码已失效，请刷新重扫</p>
        </div>
      </div>
      <span>使用 <span class="code_txt">"微信扫一扫"</span> 登录账号</span>
    </div>
    <div class="contBox" v-else>
      <div class="item">
        <FInput
          class="ipt"
          ref="mobile"
          :maxlength="11"
          v-model="formData.mobile"
          type="text"
          placeholder="请输入手机号"
        />
      </div>
      <div class="item">
        <FInput
          class="ipt"
          ref="code"
          :maxlength="6"
          v-model="formData.code"
          type="text"
          placeholder="请输入验证码"
        >
          <button
            class="btn btn-code"
            :class="{ disabled: !canSend }"
            v-text="btnText"
            @click="getCode"
          ></button>
        </FInput>
      </div>
      <button
        class="summit btn btn-act"
        @click="submit"
        :class="{ 'btn-disabled': !isCanClick }"
      >
        登录
      </button>
      <div class="reg-tip">还没有账号？ 请 <a @click="goRegister">注册</a></div>
      <div class="login-tip">
        如果您已经是
        <a class="private">【朗朗书声统编人教语文朗读指导】</a>
        小程序注册用户，请直接使用原手机账号/密码登录本平台
      </div>
    </div>
    <CodeValid ref="codeValid" @confirm="codeConfirm" v-model="showValidCode" />
  </LoginModule>
</template>
<script>
import LoginModule from "./loginModule.vue";
import FInput from "base/input/index";
import CodeValid from "business/CodeValid";
import mixin_user from "mixin/user";
import Vue from "vue";
import util from "libs/util";

let timer = null;
let interval = null;
export default {
  components: {
    LoginModule,
    FInput,
    CodeValid,
  },
  mixins: [mixin_user],
  data() {
    return {
      isCanClick: false,
      smsType: 4,
      formData: {
        mobile: "",
        code: "",
      },
      isScanLog: true,
      codeDataObj: {}, // 登录二维码信息
      isExpireTime: false, // 二维码状态
    };
  },

  watch: {
    formData: {
      handler(newVal) {
        this.isCanClick = newVal.mobile && newVal.code;
      },
      immediate: true,
      deep: true,
    },
    isExpireTime(val) {
      if (val) this.resetTime();
    },
  },
  mounted() {
    Vue.prototype.$isToLogin = 0;
    if (this.isScanLog) this.getCodeImg();
  },
  destroyed() {
    this.resetTime();
  },
  methods: {
    // 获取登录二维码
    async getCodeImg() {
      const res = await this.$get("/webLogin/getQrCode.json");
      if (res.status == 200) {
        this.codeDataObj = res.data;
        this.isExpireTime = false;
        // 轮询查询二维码状态
        interval = setInterval(() => {
          this.checkCodeStatus();
        }, 2000);
        // 二维码过期时间
        timer = setTimeout(() => {
          this.isExpireTime = true;
        }, 1000 * res.data?.expireSeconds || 10 * 60 * 1000);
      }
    },
    // 查询二维码状态
    async checkCodeStatus() {
      const res = await this.$get("/webLogin/checkQrcodeState.json", {
        ticket: this.codeDataObj?.ticket,
      });
      const { status, data } = res;
      const query = this.$route.query;
      console.log("-----rererres------", res);
      if (status == 200) {
        clearInterval(interval);
        this.formData = {
          mobile: "",
          code: "",
        };
        await this.$store.dispatch("queryUserInfo");
        this.goJumpNext();
        // this.$user.loginCallBack(query);
      } else if (status === "50015") {
        // 未扫码登录
      } else if (status === "50014") {
        // 未绑定手机号
        clearInterval(interval);
        this.$gopage("binding", { ticket: this.codeDataObj?.ticket }, true);
      } else {
        this.$toast(res.message);
      }
    },
    changeLogWay() {
      this.isScanLog = !this.isScanLog;
      this.resetTime();
      if (this.isScanLog) this.getCodeImg();
    },
    resetTime() {
      timer && clearTimeout(timer);
      interval && clearInterval(interval);
      timer = null;
      interval = null;
    },
    // 注册
    goRegister() {
      let query = this.$route.query;
      this.$gopage("register", query);
    },
    async submit() {
      const formData = this.formData;
      if (!this.isCanClick) {
        return;
      }
      const config = [
        {
          id: "mobile",
          rule: {
            required: {
              message: "请输入手机号码",
            },
            mobile: {
              message: "请输入正确的手机号码",
            },
          },
        },
        {
          id: "code",
          rule: {
            required: {
              message: "请输入验证码",
            },
          },
        },
      ];
      let { result, params } = await this.$checkForm(config, formData);
      if (!result) {
        return;
      }
      this.$loading.show();
      const res = await this.$post("/webLogin/mobileLogin.json", params);
      const query = this.$route.query;
      this.$loading.hide();
      if (res.status == 200) {
        this.formData = {
          mobile: "",
          code: "",
        };
        await this.$store.dispatch("queryUserInfo");
        // this.$user.loginCallBack(query);
        this.goJumpNext();
      } else {
        this.$toast(res.message);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~styles/user/index.less";
.topBox {
  justify-content: flex-end;
  padding-top: 10px;
  margin-bottom: -60px;
  .tips {
    width: 64px;
    height: 20px;
    background: url("~images/扫码=提示@2x.png") no-repeat;
    background-size: 100% 100%;

    &.tips1 {
      background: url("~images/手机-提示@2x.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .icon {
    width: 100px;
    height: 100px;
    background: url("~images/扫码登录@2x.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 10px;


    &.icon1 {
      background: url("~images/手机登录@2x.png") no-repeat;

      background-size: 100% 100%;
    }
  }
}

.scanBox {
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 60px;

  .code_img {
    width: 144px;
    height: 144px;
    margin-bottom: 16px;
  }
}

.codeBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 44px 0;
  color: #666666;
  font-size: 12px;

  .wrap {
    position: relative;
    width: 200px;
    height: 200px;
    margin-bottom: 16px;
    .maskBox {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      position: absolute;
      top: 0;
      left: 0;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 10px;

      .iconfont {
        font-size: 40px;
        margin-bottom: 20px;
      }
    }
  }

  .codeImg {
    width: 200px;
    height: 200px;
  }

  .code_txt {
    color: #333333;
  }
}
</style>
